import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import 'jquery-form';
import 'jquery-validation';
import '../../assets/scripts/bootstrap-modal';
import '../../assets/scripts/jquery-validation.init';
import * as helper from '../global/helper';
import swal from 'sweetalert2';
import Select from 'react-select';
import Dropzone from '../global/dropzone';
import { getProducts, getProductsByAgentID } from '../api/policyAPI';
import { getMainClients, getPrimaryClientDataByCompanyID , getClientsByGroupIDAndCompanyID } from '../api/clientAPI';
import { getClientDocumentTypes, addClientDocument, updateClientDocument } from '../api/clientDocumentAPI';
import { uploadFile } from '../api/fileAPI';
import { getAuthState } from '../../assets/scripts/login-util';

const clientDisplayName = (c) => (
    c.Type === 'Corporate'
        ? c.CompanyName
        : `${c.FirstName || ''} ${c.MiddleName || ''} ${c.LastName || ''}`.replace(/\s+/g, ' ').trim()
);

const toMemberOption = (m) => ({
    label: `${m.FirstName || ''} ${m.LastName || ''}`.replace(/\s+/g, ' ').trim(),
    value: { ID: m.ID, DisplayName: `${m.FirstName || ''} ${m.LastName || ''}`.replace(/\s+/g, ' ').trim() }
});

const AddClientDocument = (props) => {

    const meta        = props.meta || {};
    const editDoc     = meta.document || null;
    const presetClient = meta.client || null;
    const isEdit      = !!editDoc;

    const [btnLoading,      setBtnLoading]      = useState(false);
    const [clientList,      setClientList]      = useState([]);
    const [products,        setProducts]        = useState([]);
    const [documentTypes,   setDocumentTypes]   = useState([]);
    const [selectedClient,  setSelectedClient]  = useState(null); // { ID, GroupID, DisplayName }
    const [memberOptions,   setMemberOptions]   = useState([]);
    const [selectedMember,  setSelectedMember]  = useState(null); // { ID, DisplayName } | null
    const [documentDetails, setDocumentDetails] = useState({});
    const [file,            setFile]            = useState(null);
    const [docSaved,        setDocSaved]        = useState(false);

    const userDetails = getAuthState();
    const clientLocked = !!presetClient || isEdit;

    useEffect(() => {
        $('#add-client-document-modal').modal({ backdrop: 'static' });
        $('#add-client-document-modal').on('hidden.bs.modal', function () {
            props.onDismissModal('clientDocument', false);            
        });
        $('#add-client-document-modal').modal('toggle');

        fetchProducts();
        fetchDocumentTypes();

        if (presetClient) {
            setSelectedClient({
                ID: presetClient.ID,
                GroupID: presetClient.GroupID,
                DisplayName: clientDisplayName(presetClient)
            });
            setMemberOptions((presetClient.Members || []).map(toMemberOption));
        } else if (isEdit) {
            setSelectedClient({
                ID: editDoc.ClientID,
                GroupID: editDoc.GroupID,
                DisplayName: editDoc.ClientName
            });
            fetchMembers(editDoc.GroupID);
        } else {
            fetchClients();
        }

        if (isEdit) {
            setDocumentDetails({
                DocumentTypeID : editDoc.DocumentTypeID,
                DocumentName   : editDoc.DocumentName,
                Comment        : editDoc.Comment || '',
                ProductID      : editDoc.ProductID || null
            });
            if (editDoc.MemberID)
                setSelectedMember({ ID: editDoc.MemberID, DisplayName: editDoc.MemberName });
        }
    }, [props.show]);

    useEffect(() => {
        if (docSaved) {
            $('#add-client-document-modal').modal('hide');
            props.onDismissModal('clientDocument', false, '', docSaved);
        }
    }, [docSaved]);

    const fetchClients = async () => {
        try {
            // const response = await getMainClients();
            const response = await getPrimaryClientDataByCompanyID();
            setClientList(response.sort((a, b) => (clientDisplayName(a) > clientDisplayName(b) ? 1 : -1)));
        } catch (err) {
            showError(err);
        }
    };

    const fetchMembers = async (groupId) => {
        try {
            const response = await getClientsByGroupIDAndCompanyID(groupId);
            setMemberOptions(response.map(toMemberOption));
        } catch (err) {
            showError(err);
        }
    };

    const fetchProducts = async () => {
        try {
            const response = userDetails.user.categoryId != 3 ? await getProducts() : await getProductsByAgentID();
            setProducts(response.sort((a, b) => (a.Name > b.Name ? 1 : a.Name < b.Name ? -1 : 0)));
        } catch (err) {
            showError(err);
        }
    };

    const fetchDocumentTypes = async () => {
        try {
            const response = await getClientDocumentTypes();
            setDocumentTypes(response);
        } catch (err) {
            showError(err);
        }
    };

    const showError = (err) => {
        swal.fire({
            icon              : 'error',
            titleText         : 'Error!',
            text              : err.message,
            buttonsStyling    : false,
            confirmButtonClass: 'btn btn-brand',
        });
    };

    const updateDocumentDetails = (field, value) => {
        setDocumentDetails((d) => ({ ...d, [field]: value }));
    };

    const clientChangeHandler = (client) => {
        setSelectedClient({
            ID: client.ID,
            GroupID: client.GroupID,
            DisplayName: clientDisplayName(client)
        });
        setSelectedMember(null);
        setMemberOptions([]);
        fetchMembers(client.GroupID);
    };

    const fileHandler = async (f) => setFile(f);

    const removeFileHandler = (e) => {
        e.preventDefault();
        setFile(null);
    };

    const saveHandler = async (e) => {
        e.preventDefault();

        var form = $('#add-client-document-form');
        form.validate().destroy();
        form.validate({
            rules: { documentName: { required: true } }
        });
        if (!form.valid()) return;

        if (!selectedClient) {
            showError(new Error('Please select a client'));
            return;
        }
        if (!documentDetails.DocumentTypeID) {
            showError(new Error('Please select a document type'));
            return;
        }
        if (!isEdit && !file) {
            showError(new Error('Please upload a file'));
            return;
        }

        try {
            setBtnLoading(true);

            if (isEdit) {
                let newFileName = null;
                if (file) newFileName = await uploadFile(file, 'ClientDocument');
                await updateClientDocument({
                    ID             : editDoc.ID,
                    FileName       : editDoc.FileName,
                    NewFileName    : newFileName,
                    MemberID       : selectedMember ? selectedMember.ID : null,
                    ProductID      : documentDetails.ProductID || null,
                    DocumentTypeID : documentDetails.DocumentTypeID,
                    DocumentName   : documentDetails.DocumentName,
                    Comment        : documentDetails.Comment || null
                });
            } else {
                const fileName = await uploadFile(file, 'ClientDocument');
                await addClientDocument({
                    GroupID        : selectedClient.GroupID,
                    ClientID       : selectedClient.ID,
                    MemberID       : selectedMember ? selectedMember.ID : null,
                    ProductID      : documentDetails.ProductID || null,
                    DocumentTypeID : documentDetails.DocumentTypeID,
                    FileName       : fileName,
                    DocumentName   : documentDetails.DocumentName,
                    Comment        : documentDetails.Comment || null,
                    FileSizeBytes  : file.size,
                });
            }

            setDocSaved(true);
            swal.fire({
                icon              : 'success',
                titleText         : `Document ${isEdit ? 'Updated' : 'Added'} Successfully`,
                showConfirmButton : false,
                timer             : 1500,
            });
        } catch (err) {
            showError(err);
            setBtnLoading(false);
        }
    };

    return (
        <React.Fragment>
            <div
                className="modal fade"
                id="add-client-document-modal"
                tabIndex="-1"
                role="dialog"
                aria-hidden="true">

                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{isEdit ? 'Edit Document' : 'Add Document'}</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                disabled={btnLoading}>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form id="add-client-document-form" className="kt-form" onSubmit={(e) => e.preventDefault()}>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="ddlClient">Client</label>
                                            {clientLocked ? (
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={selectedClient ? selectedClient.DisplayName : ''}
                                                    disabled
                                                />
                                            ) : (
                                                <Select
                                                    value={selectedClient && { label: selectedClient.DisplayName, value: selectedClient }}
                                                    onChange={(event) => clientChangeHandler(event.value)}
                                                    name="ddlClient"
                                                    id="ddlClient"
                                                    placeholder="Select Client"
                                                    options={clientList.map(c => ({ label: clientDisplayName(c), value: c }))}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="ddlMember">Member <small className="text-muted">(Optional)</small></label>
                                            <Select
                                                value={selectedMember && { label: selectedMember.DisplayName, value: selectedMember }}
                                                onChange={(event) => setSelectedMember(event ? event.value : null)}
                                                name="ddlMember"
                                                id="ddlMember"
                                                placeholder="Select Member"
                                                isClearable
                                                options={memberOptions}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="documentName">Document Name</label>
                                            <input
                                                className="form-control"
                                                value={documentDetails.DocumentName || ''}
                                                onChange={(event) => updateDocumentDetails('DocumentName', helper.titleCase(event.target.value))}
                                                id="documentName"
                                                name="documentName"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="ddlDocumentType">Document Type</label>
                                            <Select
                                                value={documentDetails.DocumentTypeID && documentTypes.find(t => t.ID == documentDetails.DocumentTypeID)
                                                    ? { label: documentTypes.find(t => t.ID == documentDetails.DocumentTypeID).Name, value: documentDetails.DocumentTypeID }
                                                    : null}
                                                onChange={(event) => updateDocumentDetails('DocumentTypeID', event.value)}
                                                name="ddlDocumentType"
                                                id="ddlDocumentType"
                                                placeholder="Select Type"
                                                options={documentTypes.map(t => ({ label: t.Name, value: t.ID }))}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="ddlProduct">Related Product <small className="text-muted">(Optional)</small></label>
                                            <Select
                                                value={documentDetails.ProductID && products.find(p => p.ID == documentDetails.ProductID)
                                                    ? { label: products.find(p => p.ID == documentDetails.ProductID).Name, value: documentDetails.ProductID }
                                                    : null}
                                                onChange={(event) => updateDocumentDetails('ProductID', event ? event.value : null)}
                                                name="ddlProduct"
                                                id="ddlProduct"
                                                placeholder="Select Product"
                                                isClearable
                                                options={products.map(p => ({ label: p.Name, value: p.ID }))}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="comment">Comment</label>
                                            <textarea
                                                className="form-control"
                                                value={documentDetails.Comment || ''}
                                                onChange={(event) => updateDocumentDetails('Comment', event.target.value)}
                                                id="comment"
                                                name="comment"
                                                rows="1"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {!file && (<Dropzone fileHandler={fileHandler} accept="image/* pdf" />)}
                                {file && (
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="kt-notification margin-b30" style={{ backgroundColor: '#f7f8fa' }}>
                                                <a className="kt-notification__item">
                                                    <div className="kt-notification__item-icon margin-r10" onClick={() => helper.openFileHandler(file)}>
                                                        <img height="30px" width="30px" src={helper.getFileLogo(file.name)} />
                                                    </div>
                                                    <div className="kt-notification__item-details" onClick={() => helper.openFileHandler(file)}>
                                                        <div className="kt-notification__item-title kt-font-bold">
                                                            {file.name}
                                                        </div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={removeFileHandler}
                                                        className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10">
                                                        <i className="flaticon2-rubbish-bin-delete-button"></i>
                                                    </button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {isEdit && (
                                    <div className="row">
                                        <div className="col-12">
                                            <span className="kt-font-sm text-muted">
                                                Current file: {editDoc.DocumentName}. Upload a new file only to replace it.
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary margin-0 margin-r5"
                                data-dismiss="modal"
                                disabled={btnLoading}>
                                Close
                            </button>
                            <button
                                id="save-btn"
                                onClick={saveHandler}
                                type="button"
                                className={`btn btn-brand margin-0 ${btnLoading ? 'kt-spinner kt-spinner--sm kt-spinner--light' : ''}`}
                                disabled={btnLoading}>
                                {isEdit ? 'Save' : 'Upload'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AddClientDocument;
